import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiBook, FiTarget, FiEdit, FiTrendingUp, FiSmile } from 'react-icons/fi';

const BenefitsSection = () => {
  const benefits = [
    {
      icon: FiBook,
      title: "Stronger Working Memory",
      description: "They read a chapter once and actually remember what happened.",
      color: "accent-magenta"
    },
    {
      icon: FiTarget,
      title: "Improved Cognitive Flexibility",
      description: "They tackle a word problem without giving up after 30 seconds.",
      color: "accent-purple"
    },
    {
      icon: FiEdit,
      title: "Enhanced Organization & Planning",
      description: "They write a paragraph that makes sense, from the first sentence to the last.",
      color: "accent-gold"
    },
    {
      icon: FiTrendingUp,
      title: "Boosted Self-Efficacy",
      description: "They finally feel confident enough to raise their hand in class.",
      color: "accent-yellow"
    },
    {
      icon: FiSmile,
      title: "Reduced Anxiety",
      description: "They see school as a place of curiosity, not constant challenge.",
      color: "accent-lavender"
    }
  ];

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl lg:text-5xl font-playfair font-bold text-gray-900 mb-6">
            What Building a Stronger Learning Brain Feels Like For Your Child
          </h2>
        </motion.div>

        {/* Benefits Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {benefits.map((benefit, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              whileHover={{ y: -5 }}
              className="card text-center group"
            >
              <div className={`w-16 h-16 bg-${benefit.color}/10 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <SafeIcon icon={benefit.icon} className={`h-8 w-8 text-${benefit.color}`} />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{benefit.title}</h3>
              <p className="text-gray-600 leading-relaxed">{benefit.description}</p>
            </motion.div>
          ))}
        </div>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center"
        >
          <button onClick={scrollToContact} className="btn-gold text-lg px-10 py-5">
            Start Your Child's Transformation Today
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default BenefitsSection;